import { useQuery } from "@tanstack/react-query";
import { getScriptWorkspace } from "@/app/actions/messages-content/scripts/action";
import { ScriptWorkspace } from "@/app/types/messages-content/ScriptData";
import { QueryKey } from "@/app/vars/QueryKeys";

type Options = {
  avatarId?: number;
  callType: string;
  enabled?: boolean;
  initialData?: ScriptWorkspace;
};

export function buildScriptQueryKey(avatarId: number | undefined, callType: string) {
  return [QueryKey.SCRIPT, avatarId, callType];
}

export function useFetchScript(options: Options) {
  const { avatarId, callType, enabled = true, initialData } = options;

  return useQuery({
    queryKey: buildScriptQueryKey(avatarId, callType),
    queryFn: () => getScriptWorkspace(avatarId!, callType),
    enabled: enabled && !!avatarId,
    staleTime: Infinity,
    initialData,
  });
}
